export default __webpack_public_path__ + "static/media/cert-student-cpttm.afde405c.jpg";